import { combineReducers } from 'redux';

import BrandsReducer, { ReduxState as BrandsState } from './brands';
import CartReducer, { ReduxState as CartState } from './cart';
import CatalogReducer, { ReduxState as CatalogState } from './catalog';
import CategoriesReducer, { ReduxState as CategoriesState } from './categories';
import CustomerReducer, { ReduxState as CustomerState } from './customer';
import EventsReducer, { ReduxState as EventsState } from './events';
import LocationsReducer, { ReduxState as LocationsState } from './locations';
import MasonryReducer, { ReduxState as MasonryState } from './masonry';
import MerchantsReducer, { ReduxState as MerchantsState } from './merchants';
import OrdersReducer, { ReduxState as OrdersState } from './orders';
import ProductDetailsReducer, { ReduxState as ProductDetailsState } from './productDetails';
import ProductsReducer, { ReduxState as ProductsState } from './products';
import SettingsReducer, { ReduxState as SettingsState } from './settings';
import TagsReducer, { ReduxState as TagsState } from './tags';
import TicketsReducer, { ReduxState as TicketsState } from './tickets';

export interface AppState {
  Brands: BrandsState;
  Cart: CartState;
  Catalog: CatalogState;
  Categories: CategoriesState;
  Customer: CustomerState;
  Events: EventsState;
  Locations: LocationsState;
  Masonry: MasonryState;
  Merchants: MerchantsState;
  Orders: OrdersState;
  ProductDetails: ProductDetailsState;
  Products: ProductsState;
  Settings: SettingsState;
  Tags: TagsState;
  Tickets: TicketsState;
}

export default combineReducers({
  Brands: BrandsReducer,
  Cart: CartReducer,
  Catalog: CatalogReducer,
  Categories: CategoriesReducer,
  Customer: CustomerReducer,
  Events: EventsReducer,
  Locations: LocationsReducer,
  Masonry: MasonryReducer,
  Merchants: MerchantsReducer,
  Orders: OrdersReducer,
  ProductDetails: ProductDetailsReducer,
  Products: ProductsReducer,
  Settings: SettingsReducer,
  Tags: TagsReducer,
  Tickets: TicketsReducer,
});
